<template>
  <b-overlay
    :show="$apollo.loading"
    spinner-variant="primary"
  >
    <!-- search input -->
    <div class="custom-search d-flex justify-content-start">
      <b-form-group
        class="form-inline"
        label="Search"
        label-size="sm"
      >
        <b-form-input
          v-model="searchTerm"
          class="d-inline-block mr-1"
          placeholder="Search knowledge base"
          type="text"
        />
        <b-button
          v-b-modal.knowledgeBaseModal
          variant="primary"
        >
          <feather-icon icon="PlusIcon" />
          Add Knowledge Base
        </b-button>
      </b-form-group>
    </div>

    <!-- table -->
    <vue-good-table
      :columns="columns"
      :pagination-options="{
        enabled: true,
        perPage:pageLength
      }"
      :rows="rows"
      :search-options="{
        enabled: true,
        externalQuery: searchTerm }"
    >
      <template
        slot="table-row"
        slot-scope="props"
      >

        <!-- Column: Action -->
        <span v-if="props.column.field === 'action'">
          <span>
            <b-dropdown
              dropright
              no-caret
              size="sm"
              toggle-class="text-decoration-none"
              variant="link"
            >
              <template v-slot:button-content>
                <feather-icon
                  class="text-body align-middle"
                  icon="MoreVerticalIcon"
                  size="16"
                />
              </template>
              <b-dropdown-item>
                <feather-icon
                  class="mr-50"
                  icon="EditIcon"
                />
                <span>Modify</span>
              </b-dropdown-item>
              <b-dropdown-item>
                <feather-icon
                  class="mr-50"
                  icon="EyeOffIcon"
                />
                <span>Hide</span>
              </b-dropdown-item>
              <b-dropdown-item variant="danger">
                <feather-icon
                  class="mr-50"
                  icon="TrashIcon"
                />
                <span>Delete</span>
              </b-dropdown-item>
            </b-dropdown>
          </span>
        </span>

        <!-- Column: Common -->
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>

      <!-- pagination -->
      <template
        slot="pagination-bottom"
        slot-scope="props"
      >
        <div class="d-flex justify-content-between flex-wrap">
          <div class="d-flex align-items-center mb-0 mt-1">
            <span class="text-nowrap ">
              Showing 1 to
            </span>
            <b-form-select
              v-model="pageLength"
              :options="['3','5','10']"
              class="mx-1"
              @input="(value)=>props.perPageChanged({currentPerPage:value})"
            />
            <span class="text-nowrap"> of {{ props.total }} entries </span>
          </div>
          <div>
            <b-pagination
              :per-page="pageLength"
              :total-rows="props.total"
              :value="1"
              align="right"
              class="mt-1 mb-0"
              first-number
              last-number
              next-class="next-item"
              prev-class="prev-item"
              @input="(value)=>props.pageChanged({currentPage:value})"
            >
              <template #prev-text>
                <feather-icon
                  icon="ChevronLeftIcon"
                  size="18"
                />
              </template>
              <template #next-text>
                <feather-icon
                  icon="ChevronRightIcon"
                  size="18"
                />
              </template>
            </b-pagination>
          </div>
        </div>
      </template>
    </vue-good-table>
    <b-modal
      id="knowledgeBaseModal"
      size="lg"
      title="Add Knowledge Base"
      ok-title="Save"
      @ok="addAssignment"
    >
      <b-row>
        <b-col cols="12">
          <b-form-group
            label="Title"
            label-size="sm"
          >
            <b-form-input
              v-model="progressStageTitle"
              type="text"
              placeholder="Title"
              required
            /></b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Operation"
            label-size="sm"
          ><treeselect
            v-model="selectedOperation"
            :normalizer="normalizer"
            :options="operations"
            placeholder="Select Phase, Subphase or Activities"
          /></b-form-group></b-col>
        <b-col md="6">
          <b-form-group
            label="Upload file"
            label-size="sm"
          ><b-form-file v-model="file" /></b-form-group></b-col>
        <b-col md="6">
          <b-form-group
            label="Recommendation Level"
            label-size="sm"
          ><v-select
            model="recommendationLevel"
            placeholder="Recommendation Level"
            :options="['Priority', 'Interesting', 'Additional reading', 'Good read']"
          /></b-form-group></b-col>
      </b-row>
    </b-modal>
  </b-overlay>
</template>
<script>

import {
  BButton, BCol, BDropdown, BDropdownItem, BFormFile, BFormGroup, BFormInput, BFormSelect, BOverlay, BPagination, BRow,
} from 'bootstrap-vue'
import { VueGoodTable } from 'vue-good-table'
import gql from 'graphql-tag'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import vSelect from 'vue-select'

export default {
  components: {
    BRow,
    BCol,
    BFormInput,
    BFormGroup,
    BButton,
    BOverlay,
    VueGoodTable,
    BPagination,
    BFormSelect,
    BDropdown,
    BDropdownItem,
    vSelect,
    Treeselect,
    BFormFile,
  },
  data() {
    return {
      searchTerm: '',
      applicationForm: null,
      selectedRow: 0,
      pageLength: 5,
      filter: {
        status: 'Current',
      },
      columns: [
        {
          label: 'Action',
          field: 'action',
          sortable: false,
        },
        {
          label: 'Title',
          field: 'title',
        },
        {
          label: 'Operations',
          field(row) {
            if (!row.programs_operationstables.length) return '-'
            return row.programs_operationstables.map(e => e.programs_operationstables.title)
              .join(', ')
          },
        },
        {
          label: 'File',
          field: 'file',
          sortable: false,
        },
      ],
      rows: [],
      file: null,
      recommendationLevel: null,
      progressStageTitle: null,
      selectedOperation: null,
    }
  },
  methods: {
    normalizer(node) {
      return {
        id: node.id,
        label: node.title,
        children: node.programs_operationstables,
      }
    },
    addAssignment() {
      this.$apollo.mutate(
        {
          mutation: gql`mutation($data: [programs_assignmentquestionstable_insert_input!]!) {
                        insert_programs_assignmenttable_one(object: {title: ${this.assignmentTitle},type: ${this.assignmentType}, operations_id: ${this.selectedOperation}, programs_assignmentquestionstables: {data: $data}}) {
                          id
                        }
                      }`,
          variables: {
            data: this.linearizeFormBuilder,
          },
          update: () => {
            this.$apollo.queries.rows.refetch()
          },
        },
      )
      this.assignmentTitle = null; this.selectedOperation = null; this.applicationForm = null; this.assignmentType = null
    },
  },
  apollo: {
    rows: {
      query() {
        return gql`
        {
          programs_progressstagetable(where: {programs_operationstable: {program_id: {_eq: ${this.$route.params.id}}}}) {
            id
            title
            programs_operationstables {
              title
            }
          }
        }`
      },
      update: data => data.programs_assignmenttable,
    },
    operations: {
      query() {
        return gql`{
            programs_operationstable(where: {program_id: {_eq: ${this.$route.params.id}}, operations_type: {_eq: "Phase"}}) {
                  id
                  title
                  programs_operationstables(where: {operations_type: {_eq: "SubPhase"}}) {
                    id
                    title
                    programs_operationstables {
                      id
                      title
                    }
                  }
                }
              }`
      },
      update: data => data.programs_operationstable,
    },
  },
}
</script>
